export default __webpack_public_path__ + "55da6a725355728a0f5df22a4ea667ec.jpg";